export const TICKET_TERMS_SECTIONS = [
  {
    title: '1. Ticket purchases',
    body:
      'All ticket purchases are final. Tickets are non-refundable and non-exchangeable except where required by law or as stated by the organiser.',
  },
  {
    title: '2. Electronic ticket delivery',
    body:
      'Tickets will be delivered electronically to the email address provided during purchase. Customers are responsible for ensuring their email address is correct.',
  },
  {
    title: '3. Ticket security',
    body:
      'Each ticket contains a unique Ticket ID, QR Code, and/or Verification Code. These details must be kept secure and must not be shared with others.',
  },
  {
    title: '4. Single-use entry',
    body:
      'Each ticket is valid for one entry only. Once a ticket has been scanned, checked in, or redeemed, it cannot be used again.',
  },
  {
    title: '5. Duplicate or altered tickets',
    body:
      'Duplicate, copied, altered, or fraudulent tickets will be rejected and may result in refusal of entry without refund.',
  },
  {
    title: '6. Entry requirements',
    body:
      'Ticket holders must present a valid ticket, QR Code, or Verification Code upon arrival to gain entry to the event.',
  },
  {
    title: '7. Identity verification',
    body:
      'The organiser reserves the right to verify the identity of ticket holders where necessary to prevent fraud, misuse, or unauthorised ticket sharing.',
  },
  {
    title: '8. Right of admission',
    body:
      'The organiser reserves the right to refuse admission or remove attendees who fail to comply with venue rules, safety requirements, or event policies.',
  },
  {
    title: '9. Event changes',
    body:
      'Event dates, times, venues, performers, speakers, schedules, and programme details may be changed where reasonably necessary.',
  },
  {
    title: '10. Event cancellation',
    body:
      'If the organiser cancels the event and no alternative date is offered, eligible ticket holders may receive a refund in accordance with the organiser’s refund policy.',
  },
  {
    title: '11. Event postponement',
    body:
      'If the event is postponed or rescheduled, purchased tickets will remain valid for the revised date unless otherwise communicated by the organiser.',
  },
  {
    title: '12. Email delivery issues',
    body:
      'The organiser is not responsible for lost, deleted, inaccessible, or undelivered tickets caused by incorrect customer information or email provider issues.',
  },
  {
    title: '13. Acceptance of terms',
    body:
      'By purchasing a ticket, you acknowledge and agree to these Terms & Conditions and any additional event-specific rules communicated by the organiser.',
  },
];

export const TICKET_TERMS_SUMMARY =
  'By purchasing tickets you agree to our';
